import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=2d67cb77&scoped=true&"
import script from "./BaseListItem.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseListItem.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=2d67cb77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67cb77",
  null
  
)

export default component.exports